<template>
	<Bar 
    		ref="chart"
    		:data="computedData"
    		:options="chartOptions"
    		:plugins="plugins"
    	/>
</template>

<script>
import colorLib from '@kurkle/color';
import { Bar } from 'vue-chartjs'
import { 
		Utils, 
		Chart, 
		ArcElement, 
		LineController, 
		LineElement, 
		BarController, 
		BarElement, 
		PieController, 
		RadarController, 
		PointElement, 
		LinearScale, 
		RadialLinearScale, 
		CategoryScale, 
		TimeSeriesScale, 
		Title, 
		Legend, 
		Filler, 
		Tooltip 
	} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(LineController, ArcElement, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip, ChartDataLabels);

export default {
	name: 'BarChart',
	components: {
		Bar
	},
	props: {
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		chartData: {
			type: Object,
			default: {
				options: {}
			}
		},
		tooltipDefaultConfig: Object,
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	},
	data() {
		// console.log(this.chartData.options)
		return {
			cdOptions: this.chartData.options,
			}
	},
	created() {
		// alert(1)
		// console.log(this.chartData.data)
	},
	computed: {
		computedData() {
			// console.log('computedData::', this.data)
			// console.log('hasData::', this.hasData)
			if ( ! this.hasData ) {
				let data = JSON.parse(JSON.stringify(this.data));
				data.datasets = [
							{
								label: this.feTheme.charts_no_data_text,
								data: [1, 2, 3, 4, 2, 0],
								borderColor: '#c1d2c1',
			                    backgroundColor: '#d1d1d1',
							}
						]
				data.labels = ['', '', '', '', '', '']
				return data
			}
			return this.data
		},
		chartOptions() {
			const _this = this,
				cdOptions = this.cdOptions

			const scalesConfig = {
					y: {
					beginAtZero: cdOptions.min ? false : true,
					suggestedMax: cdOptions.max ? Math.ceil(cdOptions.max) : false,
					suggestedMin: cdOptions.min ? cdOptions.min : 0,
					grid: {
						tickLength: 10,
						drawOnChartArea: true
					},
					ticks: {
						stepSize: cdOptions.step_size_y ? cdOptions.step_size_y : .5,
						precision: 0,
					}

				}
			}

			return {
				grouped: true,
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					tooltip: {
						..._this.tooltipDefaultConfig
					},
					datalabels: {
						display: false,
					},
				},
				scales: scalesConfig
			}
		}
	},
	methods: {

	}
}
</script>